import React, {Component} from "react";
import PropTypes from 'prop-types';
import {Table, Button} from "reactstrap";
import {GetFormValue3Tiers, SyncDelete} from 'datasync-core'
import {useSelector, useDispatch } from 'react-redux';
import {deleteBlog, revertStatusBlogs} from "../../redux/blogSlice";
import {openModalBlog} from "../../redux/modalSlice";
import {openModalStat, openModal} from "../../redux/modalSlice";
import {globals} from "../Globals/Globals"
import Blog from "../Blog/Blog";

const BlogsRawTableDataSync = (props) =>{
    const {deleteBlog_result} = useSelector((state) => state.blogs)
    const dispatch = useDispatch();

    React.useEffect(() => {
        // eslint-disable-next-line no-unused-vars
        let isMounted = true

        if (deleteBlog_result.status == "deleted"){
            try{
                dispatch(openModal({title:"Blog supprimé"}));
            }
            finally{
                dispatch(revertStatusBlogs())
            }
        }

        // Cleanup function
        return () => {
            isMounted = false;
        }
    }, [dispatch, deleteBlog_result]);

     /**
     * 
     * @param {*} this 
     * @param {*} handleManager 
     * @param {*} userItem 
     * @param {*} data_guid 
     */
    const handleManager = async (p_s_item_key, p_callback_handler) => {
        try {
            if (globals.parameters.debugging) console.log("handleManager::p_s_item_key =>", p_s_item_key)
                p_callback_handler(props.blog_list.find((item) => item.data_guid == p_s_item_key))
        } catch (error) {
            alert(`handleManager for ${p_callback_handler} raise error ${error.message}`)
        }
    }
    

    const tableRendering = () => {
        let table_body = null;

        if (!((props.blog_list != null) && (props.blog_list.length > 0))){
            table_body = <tr><td colSpan="4">Pas de blog disponible</td></tr>;
        }
        else{
            table_body = props.blog_list.map((blogItem,i)=>{
                return  <tr key={blogItem.data_guid} className="thumbnail">
                            <td id="table-item-container">
                                <div id="table-item">
                                    <Blog
                                        key={blogItem.data_guid}
                                        title={blogItem.data_blob.data_tier.blog_title}
                                        text={blogItem.data_blob.data_tier.blog_text}
                                        pictureURL={blogItem.data_blob.data_tier.blog_photo}
                                        blog_link={blogItem.data_blob.data_tier.blog_link}
                                    />
                                </div>
                                <div id="table-commands">
                                    {!props.read_only &&
                                        <div className="cmd_btn_delete">
                                            <Button onClick={()=>{handleManager(blogItem.data_guid, (blogObject)=>{
                                                dispatch(openModal(
                                                                    {title:`Supprimer le blog ${blogObject.data_blob.data_tier.blog_title} ?`,
                                                                        okCallBack:(DialogObject)=>{dispatch(deleteBlog(blogObject))}})) })}}
                                            style={{cursor:"pointer"}}>Effacer</Button>
                                        </div>}
                                    
                                    {!props.read_only &&
                                        <div className="cmd_btn_update">
                                            <Button onClick={()=>{handleManager(blogItem.data_guid, (blogObject)=>{dispatch(openModalBlog({blog_data_guid:blogObject, read_only:false}))})}} 
                                            style={{cursor:"pointer"}}>Modifier</Button>
                                        </div>}
                                </div>
                            </td>
                        </tr>});
                }

        return(
            <Table striped responsive={true}>
               <tbody>
                    {table_body}
                </tbody>
            </Table>
            );
    }

    return (
        <>
            {tableRendering()}
        </>);
}

BlogsRawTableDataSync.propTypes = { 
    table: PropTypes.bool,
};

BlogsRawTableDataSync.defaultProps = {
    table:true,
};



export default BlogsRawTableDataSync;